module.exports = __webpack_public_path__ + "images/psp/FeaturedImages/atv-2.webp";